import React, { useState, useCallback } from "react";
import {
  Container,
  Col,
  Row,
  CardBody,
  Card,
  Button,
  CardFooter,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

function PdfViewer({ file }) {
  const [numPages, setNumPages] = useState(null);

  const onLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
  }, []);

  return (
    <div
      style={{ height: "70vh", overflowY: "auto", border: "1px solid #ccc" }}
    >
      <Document
        file={file}
        onLoadSuccess={onLoadSuccess}
        onLoadError={(error) => console.error("PDF load error:", error)}
        loading={<div>Chargement du PDF...</div>}
        error={<div>Impossible de charger le PDF.</div>}
      >
        {numPages &&
          Array.from({ length: numPages }, (_, i) => (
            <Page key={i + 1} pageNumber={i + 1} width={550} />
          ))}
      </Document>
    </div>
  );
}

function Terms() {
  const history = useHistory();
  const [showLoading, setShowLoading] = useState(false);

  const approveTerms = () => {
    setShowLoading(true);
    fetch("/api/v1/version/approve_terms", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == "200") {
          sessionStorage.setItem("termsAgreed", "true");
          redirectToDashboard();
        } else {
          toast.error("A problem occured while communicating with the server", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        toast.error("A problem occured while communicating with the server", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
      });
  };
  const redirectToDashboard = () => {
    const location = {
      pathname: "/admin/dashboard",
    };
    history.push(location);
  };

  return (
    <>
      <ToastContainer />
      <div className="login-page">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Container>
          <Row>
            <Col md="6" className="loginInput">
              <Card className="card-login">
                <CardBody>
                  <PdfViewer file="/virtuoso.pdf" />
                </CardBody>
                <CardFooter style={{ textAlign: "center" }}>
                  <Button
                    className="btn-round"
                    color="info"
                    onClick={approveTerms}
                  >
                    I agree to the Terms and Conditions Above
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`,
          }}
        />
      </div>
    </>
  );
}

export default Terms;
